import request from '@/utils/request'

// 查询资质认定检验检测机构列表
export function listZzrdjyjcjg(query) {
  return request({
    url: '/web/rzfw/zzrdjyjcjg/list',
    method: 'get',
    params: query
  })
}
